import React from "react";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { error: null });
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info.componentStack);
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return <div role="alert" className="mx-auto max-w-xl px-6 py-16 text-foreground">
        <h1 className="text-xl font-semibold">Something went wrong</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          This page hit an error and could not be shown.
        </p>
        <pre className="mt-4 overflow-auto whitespace-pre-wrap rounded-md border border-border bg-muted p-3 text-xs">
          {error.message}
        </pre>
        <button
      type="button"
      onClick={() => window.location.reload()}
      className="mt-4 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
    >
          Reload
        </button>
      </div>;
  }
}
export {
  ErrorBoundary
};
